/**
 * Closes a modal when the Escape key is pressed.
 *
 * Usage:
 *   - Call `this.openEscapeClosable()` to show the modal and start listening.
 *   - Call `this.closeEscapeClosable()` to close it programmatically.
 *   - The exposed `isEscapeClosableActive` data property drives v-if / v-show.
 *   - Override `onEscapeClosableClosed()` to react after the modal closes.
 */
export default {
  data() {
    return {
      isEscapeClosableActive: false,
    };
  },

  methods: {
    openEscapeClosable() {
      this.isEscapeClosableActive = true;
      window.addEventListener('keydown', this.onEscapeClosableKeyDown);
    },

    closeEscapeClosable() {
      if (!this.isEscapeClosableActive) {
        return;
      }

      this.isEscapeClosableActive = false;
      window.removeEventListener('keydown', this.onEscapeClosableKeyDown);
      this.onEscapeClosableClosed();
    },

    /** Override in consuming component to react after the modal closes. */
    onEscapeClosableClosed() {},

    onEscapeClosableKeyDown(event) {
      if (event.key === 'Escape') {
        this.closeEscapeClosable();
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.onEscapeClosableKeyDown);
  },
};
